var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 273.4 273.4",
    style: {
      enableBackground: "new 0 0 273.4 273.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#233C4B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3341",
    className: "st0",
    points: "165,159.2 170.8,131.2 173,159.2 185.4,159.2 179.6,114.7 166.3,114.7 160.1,141.4  153.8,114.7 140.5,114.7 134.7,159.2 147.2,159.2 149.4,131.2 155.2,159.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon3345",
    className: "st0",
    points: "203.7,114.7 191.7,114.7 191.7,159.2 220.1,159.2 220.1,149.8 203.7,149.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3349",
    "inkscapeConnector-curvature": 0,
    className: "st0",
    d: "M81.8,114.7H66.7l-13.3,44.5h13.3l1.8-8H80l1.8,8h13.3 L81.8,114.7L81.8,114.7z M74.2,124.5l4,18.2h-8L74.2,124.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3353",
    "inkscapeConnector-curvature": 0,
    className: "st0",
    d: "M127.2,127.2c-11-9.7-28.3-5.7-28.5,3.1 c-2.5-16.4,17.3-19.9,28.5-14.7C127.4,118.2,127.6,121.1,127.2,127.2L127.2,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3355",
    "inkscapeConnector-curvature": 0,
    className: "st0",
    d: "M118,132.4c-2.8-1.1-6.8-2.1-6.8-5.2c0-1.3,0.5-2.7,3.1-3.6 c-8.9,0.9-11.9,11.7-2,17.1c1.7,0.9,4.7,1.9,4.7,5.1c0,3.8-4.1,5.1-6.8,5.1c-4.5-0.1-8.1-1.7-12.3-4.6V157 c4.9,2.1,12.9,4.5,20.9,2.1c6.5-2,12.1-7.4,12.1-13.2C130.7,136.4,122.5,134.2,118,132.4L118,132.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsml);
export default __webpack_public_path__ + "static/media/ASML.640c545130542b06d11e807a6a25210b.svg";
export { ForwardRef as ReactComponent };